if (!customElements.get('product-form')) {
  // Attachment (mirror kit) product. Checked by product, not variant, so it keeps working if variants change.
  const ATTACHMENT_PRODUCT_ID = 7485537812708;
  const ATTACHMENT_PATH = '/products/glue-for-mirrored-fixtures';
  const SHOW_ATTACHMENT_POPUP = false;

  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      // The popup's "Yes, Add to cart" is a plain link to the attachment page,
      // so the shopper picks the attachment type there. No script needed.
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          return fetch('/cart.js')
            .then((r) => r.json())
            .then((cart) => this.showConfirmation(response, cart))
            .catch((error) => {
              console.error('Error fetching cart:', error);
              this.cartNotification.renderContents(response);
            });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    showConfirmation(response, cart) {
      if (!SHOW_ATTACHMENT_POPUP) {
        this.cartNotification.renderContents(response);
        return;
      }
      const hasAttachment = cart.items.some((i) => i.product_id == ATTACHMENT_PRODUCT_ID);
      const onAttachmentPage = window.location.pathname == ATTACHMENT_PATH;
      const popupButton = document.getElementById('ProductPopup-qtonix');

      if (hasAttachment || onAttachmentPage || !popupButton) {
        this.cartNotification.renderContents(response);
      } else {
        this.cartNotification.updateContents(response);
        popupButton.click();
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
